module.exports = "<div class=\"marker-list\" ng-if=\"vm.sequencer.markers.length\">\n<span ng-repeat=\"marker in vm.sequencer.markers\">\n  <span style=\"cursor:pointer;outline:none;\" \n  ng-click=\" vm.sequencer.goToMarker(marker)\" \n  ng-class=\"{'active': marker.active}\" \n  class=\"beat marker\">{{marker.key}}</span>\n  <span ng-if=\"$index < vm.sequencer.markers.length-1\"> - </span>\n\n</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/web/seq/marker-list.html
// module id = 206
// module chunks = 0